import { createTypes } from 'reduxsauce'
 
export default createTypes(`
  SAVE_LINE_ID

  FETCH_GEOJSON_DATA
  FETCH_GEOJSON_DATA_SUCCESS
  FETCH_GEOJSON_DATA_FAILURE
 
`, {});
